import React from 'react';

const ContaCorrenteProcessoContext = React.createContext();

export default ContaCorrenteProcessoContext;
